/* gary-v-modal.jsx — featured archive: 2016 Gary V interview
 *
 * Placeholder embed playing the existing public YouTube version
 * (https://www.youtube.com/watch?v=GkP-FNrjczg). Will swap to a
 * self-hosted re-cut when face-aware reframe lands (see Linear F.10).
 *
 * Pattern: small operator-terminal CTA strip → modal with YouTube iframe.
 * iframe is NOT mounted until modal opens (saves bandwidth + autoplay rights).
 */

import React from 'react';
import { AsciiBadge } from './components.jsx';

const GARY_V_VIDEO_ID = "GkP-FNrjczg";

function GaryVFeatured() {
  const [open, setOpen] = React.useState(false);

  // Body scroll lock + ESC to close + Plausible event
  React.useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", onKey);

    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible("video_play", { props: { slug: "garyv-2016", source: "homepage-archive" } });
    }

    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <>
      <section
        id="featured-archive"
        data-section="featured"
        className="section-pad"
        style={{ paddingTop: 32, paddingBottom: 32 }}
      >
        <div className="container">
          <div className="box-head">
            <AsciiBadge glyph="arrow" count={3} />
            <span>// from the archive — 2016</span>
            <span className="rule" />
          </div>

          <div
            className="mt-32"
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr)",
              gap: 0,
              border: "1px solid var(--amber, #f5f3ec)",
              padding: "clamp(20px, 4vw, 40px)",
              background: "transparent",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 16, minWidth: 0 }}>
              <div style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--fg-3, #888)" }}>
                $ play /archive/garyv-2016.mp4
              </div>

              <h2 style={{
                margin: 0,
                fontSize: "clamp(22px, 3.4vw, 36px)",
                lineHeight: 1.2,
                color: "var(--fg, #e8e6dc)",
                fontWeight: 700,
              }}>
                I interviewed Gary Vaynerchuk in 2016. <span style={{ color: "var(--amber, #f5f3ec)" }}>17 minutes on regret, fear, and what wins.</span>
              </h2>

              <p style={{
                margin: 0,
                fontSize: "clamp(14px, 1.6vw, 16px)",
                lineHeight: 1.6,
                color: "var(--fg-2, #c9c7bd)",
                maxWidth: "70ch",
              }}>
                Sat down with him for my old company brick&amp;mobile. The advice still holds.
                Re-released here as a placeholder — cleaner cut + Shorts coming.
              </p>

              <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", marginTop: 8 }}>
                <button
                  type="button"
                  onClick={() => { setOpen(true); window.plausible?.("video_play", { props: { slug: "garyv-2016-brick-mobile" } }); }}
                  aria-haspopup="dialog"
                  aria-expanded={open}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "12px 20px",
                    background: "var(--amber, #f5f3ec)",
                    color: "#000",
                    border: "1px solid var(--amber, #f5f3ec)",
                    fontSize: 13,
                    letterSpacing: "0.16em",
                    textTransform: "uppercase",
                    fontWeight: 700,
                    cursor: "pointer",
                    fontFamily: "inherit",
                  }}
                >
                  <span aria-hidden="true">▶</span>
                  <span>watch · 17 min</span>
                </button>

                <span style={{ fontSize: 11, color: "var(--fg-3, #888)", letterSpacing: "0.12em" }}>
                  2016 · brick&amp;mobile · uncut
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="garyv-modal-title"
          onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(0, 0, 0, 0.92)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "clamp(16px, 4vw, 48px)",
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 1200,
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              color: "var(--fg, #e8e6dc)",
              fontSize: 12,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
            }}>
              <span id="garyv-modal-title">// archive · gary v · 2016</span>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="Close video"
                autoFocus
                style={{
                  background: "transparent",
                  border: "1px solid var(--fg-3, #888)",
                  color: "var(--fg, #e8e6dc)",
                  padding: "6px 12px",
                  fontSize: 12,
                  letterSpacing: "0.16em",
                  fontFamily: "inherit",
                  cursor: "pointer",
                }}
              >
                close · esc ✕
              </button>
            </div>

            <div style={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%",
              border: "1px solid var(--amber, #f5f3ec)",
              background: "#000",
            }}>
              <iframe
                src={`https://www.youtube.com/embed/${GARY_V_VIDEO_ID}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
                title="Kevin Zicherman interviews Gary Vaynerchuk — 2016"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

Object.assign(window, { GaryVFeatured });

export { GaryVFeatured };
